import { exportInvoice as exportInvoiceElectricity } from "../actions/invoices";
import { exportInvoice as exportInvoiceMultipoint } from "../../../actions/invoicesMultipoint";
import { exportInvoice as exportInvoiceGas } from "../actions/invoicesGas";
import { exportInvoiceHistoric } from "../actions/invoices";
import useAuth from '@/components/Authentication/hooks/useAuth';
import { useAppDispatch } from "@/hooks";
import { InvoicesTypes } from "../types/invoices";

interface UseInvoicesDetailProps {
  invoiceId: number
}

interface HandleDownloadProps {
  type: InvoicesTypes,
  option: "pdf" | "signed_pdf" | "curve_csv" | "signed_xml",
  historic: boolean
}

export const useInvoicesDetail = ({invoiceId}: UseInvoicesDetailProps) => {
  const dispatch = useAppDispatch();
  const { token } = useAuth();

  const handleDownload = async ({type, option, historic}: HandleDownloadProps) => {
    if (historic) {
      dispatch(exportInvoiceHistoric(token, invoiceId));
    }
    else {
      if (type === "multipoint") {
        await dispatch(exportInvoiceMultipoint(token, invoiceId, option))
      }
      if (type === "electricity") {
        await dispatch(exportInvoiceElectricity(token, invoiceId, option));
      }
      if (type === "gas") {
        await dispatch(exportInvoiceGas(token, invoiceId, option))
      }
    }
  }

  return { 
    handleDownload,
  }
}